module.exports = __webpack_public_path__ + "static/img/loginbg.aa822256.png";